import {
    Navigate,
} from 'react-router-dom'

import {
    useSkyNetRoutes,
} from 'app/SkyNetRoutes'
import {
    CommonRoutes,
} from 'app/enums/common.enums'

import useTransportPlannerRoutes from 'app/SkyNetRoutes/hooks/useTransportPlannerRoutes'
import NewSimulation from './NewSimulation'
import SavedSimulation from './SavedSimulation'
import SavedSimulations from './SavedSimulations'
import Co2simulations from './Co2simulations'

const TransportPlanner = () => {
    const Routes = useTransportPlannerRoutes()

    return useSkyNetRoutes({
        routes: [
            {
                path: Routes.NewSimulation.route,
                element: <NewSimulation />,
            },
            {
                path: [
                    Routes.Simulation.route,
                    Routes.Simulation.stringParams,
                ].join(CommonRoutes.Slash),
                element: <SavedSimulation />,
            },
            {
                path: Routes.CO2Calculation.route,
                element: <Co2simulations />,
            },
            {
                path: Routes.SavedSimulations.route,
                element: <SavedSimulations />,
            },
            {
                path: CommonRoutes.Slash,
                element: <Navigate
                    to={Routes.NewSimulation.route}
                    replace
                />,
            },
        ],
    })
}

export default TransportPlanner
